export default __webpack_public_path__ + "static/media/back_profile3.3053da05.jpg";